// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_2 from 'D:/frontend-hrm/src/models/human-management';
import model_3 from 'D:/frontend-hrm/src/models/metadata-management';
import model_4 from 'D:/frontend-hrm/src/models/metadata';
import model_5 from 'D:/frontend-hrm/src/models/title-group-management';
import model_6 from 'D:/frontend-hrm/src/models/title-management';
import model_7 from 'D:/frontend-hrm/src/.umi-production/plugin-initialState/@@initialState';
import model_1 from 'D:/frontend-hrm/src/models/currentUser';

export const models = {
model_2: { namespace: 'human-management', model: model_2 },
model_3: { namespace: 'metadata-management', model: model_3 },
model_4: { namespace: 'metadata', model: model_4 },
model_5: { namespace: 'title-group-management', model: model_5 },
model_6: { namespace: 'title-management', model: model_6 },
model_7: { namespace: '@@initialState', model: model_7 },
model_1: { namespace: 'currentUser', model: model_1 },
} as const
